export const GLOBAL_UPDATE_PRESET_OR_PROPERTY = 'GLOBAL_UPDATE_PRESET_OR_PROPERTY';
export const globalUpdatePresetOrProperty = (key, value) => ({
  type: GLOBAL_UPDATE_PRESET_OR_PROPERTY,
  payload: {
    key,
    value,
  },
});
